<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Index</el-breadcrumb-item>
            <el-breadcrumb-item>Fusion Benchmarks</el-breadcrumb-item>
        
        </el-breadcrumb>




        <!-- 卡片视图区 -->
        <el-card>

            <el-row :gutter="25">

                <el-col :span="10">
                    <!-- 搜索添加 -->
                    <el-input placeholder="Enter dataset name">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>

                <el-col :span="4" v-if="isAdmin">
                    <el-button type="primary" @click="addDialogVisible = true">Add Dataset</el-button>
                </el-col>

            </el-row>

            <!-- 数据集列表 -->
            <el-table :data="datasetlist" border stripe>
                <el-table-column type="index"></el-table-column>
                <el-table-column label="Dataset Name" prop="Name"></el-table-column>
                <el-table-column label="Amount" prop="NumImgs"></el-table-column>
                <el-table-column label="Description" prop="Description"></el-table-column>
                <el-table-column label="Source" prop="SrcPaper"></el-table-column>
                <el-table-column label="Operation">
                    <template slot-scope="scope">

                        <!-- 下载 -->
                        <el-tooltip effect="dark" content="Download Dataset" placement="top-start" :enterable="false">
                            <el-button type="primary" icon="el-icon-download" size="mini"
                                @click="downloadDataset(scope.row.DatasetID)"></el-button>
                        </el-tooltip>

                        <!-- 查看 -->
                        <el-tooltip effect="dark" content="View Examples" placement="top-start" :enterable="false">
                            <el-button type="success" icon="el-icon-view" size="mini"
                                @click="viewDataset(scope.row.DatasetID)"></el-button>
                        </el-tooltip>

                        <!-- 删除 -->
                        <el-tooltip
                            v-if="isAdmin"
                            effect="dark"
                            content="Delete Dataset"
                            placement="top-start"
                            :enterable="false"
                        >
                            <el-button
                                type="danger"
                                icon="el-icon-delete"
                                size="mini"
                                @click="deleteDataset(scope.row.DatasetID)"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>



            <!-- 创建添加数据集对话框 -->
            <el-dialog
                v-if="isAdmin"
                title="Add Dataset"
                :visible.sync="addDialogVisible"
                width="50%"
                @close="addDialogClosed"
            >
                <el-form :model="form">
                    <el-form-item label="Dataset Name" required>
                        <el-input v-model="form.Name"></el-input>
                    </el-form-item>
                    <el-form-item label="Paper Name">
                        <el-input v-model="form.SrcPaper"></el-input>
                    </el-form-item>
                    <el-form-item label="Description">
                        <el-input type="textarea" v-model="form.Description"></el-input>
                    </el-form-item>
                    <el-form-item label="File Upload">
                        <el-upload class="upload-demo" drag action='' :on-change="handleChange"
                            :before-upload="beforeUpload" :file-list="fileList" accept=".zip" :auto-upload="false">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">Drag here, or <em>Click to Upload</em></div>
                        </el-upload>

                        <div v-if="fileError" class="error">{{ fileError }}</div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submit">Create Dataset</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>





            <el-dialog title="View Dataset" :visible.sync="viewDialogVisible" width="50%" @close="addviewDialogClosed">
                <div style="margin-bottom: 20px; font-size: 16px; font-weight: bold;">File List (first 10 images only)</div>

                <!-- 文件列表 -->
                <div style="margin-bottom: 20px; display: flex; flex-wrap: wrap; gap: 10px;">
                    <el-button v-for="(image, index) in filenames_list" :key="index" @click="setImage(image)"
                        class="image-button" style="flex: 1 1 calc(33.333% - 10px); max-width: 150px;">
                        {{ image }}
                    </el-button>
                </div>

                <!-- 图片展示部分 -->
                <div style="display: flex; justify-content: space-between; align-items: center; gap: 30px;">
                    <div style="text-align: center; flex: 1;">
                        <img :src="this.vi_imageUrl" alt="Column A" style="width: 100%; max-width: 250px; height: auto;" />
                        <div style="margin-top: 10px;">Modality A</div>

                    </div>
                    <div style="text-align: center; flex: 1;">
                        <img :src="this.ir_imageUrl" alt="Column B" style="width: 100%; max-width: 250px; height: auto;" />
                        <div style="margin-top: 10px;">Modality B</div>
                    </div>
                </div>
            </el-dialog>


        </el-card>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import JSZip from 'jszip';

export default {
    name: "Index",
    data() {
        return {

            isAdmin: false,
            datasetlist: [],// 数据集列表
            viewDialogVisible: false,// 查看对话框显示

            addDialogVisible: false,// 创建对话框显示
            Authorization: '',
            form: {
                Name: '',
                SrcPaper: '',
                Description: ''
            },
            fileList: [],
            fileError: '',


            filenames_list: [], //文件名列表


            acquireimgaeForm: {

                DatasetID: '',//数据库ID
                FileName: '',//图片名称
                FileType: ''//ir或者vi


            },

            vi_imageUrl: '', //可见光图片地址
            ir_imageUrl: '', //红外图片地址



        }

    },
    created() {


        var user = JSON.parse(sessionStorage.getItem("user"));
        console.log(user);

        if (user) {
            this.Authorization = "Bearer " + user.access_token;
            this.isAdmin = Number(user.Level) === 1;
        }

        console.log(this.Authorization);
        console.log("isAdmin:", this.isAdmin);

        this.getDatasetList();
    },
    methods: {

        // async getDatasetList() {
        //     // 调用get请求
        //     try {
        //         const response = await this.$http.get("/dataset/getall", {
        //             headers: {
        //                 "Authorization": this.Authorization,
        //                 "Content-Type": "application/json"
        //             }
        //         });
        //         console.log(response);
        //         this.datasetlist = response.data;
        //         console.log(this.datasetlist);
        //     } catch (error) {
        //         console.error(error);
        //         this.$message.error(error.response.data.msg || 'Failed to fetch dataset list');
        //     }
        // },
        async getDatasetList() {
            // 调用get请求
            try {
                const response = await this.$http.get("/dataset/getall", {
                    headers: {
                        "Authorization": this.Authorization,
                        "Content-Type": "application/json"
                    }
                });

                // 使用 JSON.stringify() 查看数据内容
                console.log(JSON.stringify(response.data, null, 2));  // 格式化输出

                this.datasetlist = response.data;
                // 打印 datasetlist 的实际内容
                console.log(JSON.parse(JSON.stringify(this.datasetlist)));  // 防止响应式属性影响
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to fetch dataset list');
            }
        },
        async beforeUpload(file) {




            // 重置错误信息  
            this.fileError = '';

            // 使用 JSZip 读取 ZIP 文件内容  
            const zip = new JSZip();
            try {
                const contents = await zip.loadAsync(file); // 异步加载 zip 文件  


                // 检查是否包含 名为 vi 和 ir 文件 
                // 检查是否包含名为 "vi" 和 "ir" 的文件  
                const fileNames = Object.keys(contents.files);

                const hasVi = fileNames.some(name => name.includes("vi"));
                const hasIr = fileNames.some(name => name.includes("ir"));



                if (!hasVi || !hasIr) {
                    this.fileError = 'The ZIP file must contain at least one "vi" file and one "ir" file';
                    return false; // 返回 false 表示不通过验证  
                }

                // 文件有效  
                this.fileError = '';
                return true; // 返回 true 表示通过验证  

            } catch (error) {
                this.fileError = 'Failed to read ZIP file';
                console.error(error);
                return false; // 返回 false 表示不通过验证  
            }
        },

        handleChange(file) {

            this.fileList.push(file);


        },

        async submit() {

            if (!this.isAdmin) {
                this.$message.error("Only administrators can create datasets");
                return;
            }

            const confirmResult = await this.$confirm('Are you sure you want to create this dataset?', 'Upload Dataset', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).catch(err => err)

            if (this.fileList.length === 0) {
                this.fileError = 'No file uploaded';
                return;
            }

            // 开始显示加载动画
            const loading = this.$loading({
                lock: true,
                text: 'Uploading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const formData = new FormData();
            formData.append('Name', this.form.Name);
            formData.append('SrcPaper', this.form.SrcPaper);
            formData.append('Description', this.form.Description);
            formData.append('data', this.fileList[0].raw); // 只上传第一个文件

            try {
                const response = await this.$http.post("/dataset/create", formData, {
                    headers: {
                        "Authorization": this.Authorization
                    }
                });

                this.$message.success(response.data.msg);
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to create dataset');
            } finally {
                // 关闭加载动画
                loading.close();
                this.addDialogVisible = false;
                this.fileList = [];
                this.form.Name = '';
                this.form.SrcPaper = '';
                this.form.Description = '';
                this.fileError = '';
                this.getDatasetList();
            }
        },

        // 删除数据集
        async deleteDataset(DatasetID) {
            // 弹框
            const confirmResult = await this.$confirm('This action will permanently delete the dataset. Continue?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).catch(err => err)
            // 成功删除为confirm 取消为 cancel
            if (confirmResult != 'confirm') {
                return this.$message.info("Deletion cancelled");
            }
            // try {
            //     const response = await this.$http.delete("/dataset/delete?id=" + id, {
            //         headers: {
            //             "Authorization": this.Authorization,
            //             "Content-Type": "application/json"
            //         }
            //     });
            //     this.$message.success(response.data.msg);
            //     this.getDatasetList();
            // } catch (error) {
            //     console.error(error);
            //     this.$message.error(error.response.data.msg || 'Failed to delete dataset');
            // }
            console.log(DatasetID);
            console.log({ "DatasetID": DatasetID });
            try {
                const response = await this.$http.post("/dataset/delete", { "DatasetID": DatasetID },
                    {
                        headers: {
                            "Authorization": this.Authorization,
                            "Content-Type": "application/json"
                        }
                    }
                );

                this.$message.success(response.data.msg);
                this.getDatasetList();
            } catch (error) {
                console.error(error);
                this.$message.error(error.response.data.msg || 'Failed to delete dataset');
            }
        },


        // 下载数据集
        async downloadDataset(DatasetID) {
            try {
                // 请求文件的 Blob 数据
                console.log(this.Authorization);

                const response = await this.$http.get("/dataset/download?DatasetID=" + DatasetID,
                    {
                        headers: {
                            "Authorization": this.Authorization,
                            "Content-Type": "application/json"
                        },
                        responseType: 'blob'  // 关键：设置 responseType 为 'blob'
                    }
                );



                // 创建 Blob URL
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                const fileUrl = URL.createObjectURL(blob);

                // 创建 a 标签并触发下载
                const a = document.createElement('a');
                a.href = fileUrl;
                a.download = `dataset_${DatasetID}.zip`; // 或者使用文件名
                a.click();

                // 释放 Blob URL
                URL.revokeObjectURL(fileUrl);
            } catch (error) {
                console.error(error);
                this.$message.error('Failed to download dataset');
            }
        },


        // 查看数据集
        async viewDataset(DatasetID) {

            this.acquireimgaeForm.DatasetID = DatasetID;

            try {


                const response = await this.$http.get("/dataset/getfilenames?DatasetID=" + DatasetID,
                    {
                        headers: {
                            "Authorization": this.Authorization,
                            "Content-Type": "application/json"
                        },
                    }
                );

                this.$message.success(response.data.msg);
                console.log(response.data);

                // 如果你前面已经做了“最多显示前10张”，就保留这版
                this.filenames_list = (response.data.name_list || [])
                    .slice()
                    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
                    .slice(0, 10);

                this.viewDialogVisible = true;

                // 默认选中第一张图片
                if (this.filenames_list.length > 0) {
                    this.setImage(this.filenames_list[0]);
                }

            } catch (error) {
                console.error(error);
                this.$message.error('Failed to load dataset');
            }
        },

        // 设置图片
        setImage(image) {
            this.acquireimgaeForm.FileName = image;
            this.acquireimgaeForm.FileType = "vi";
            console.log(this.acquireimgaeForm);

            this.getImage();
        },

        // 获取图片
        async getImage() {
            try {



                //可见图像获取
                this.acquireimgaeForm.FileType = "vi";

                const queryParams = new URLSearchParams(this.acquireimgaeForm); // 如果需要发送对象，可以先转换成字符串

                const response = await this.$http.get(`/dataset/getfile?${queryParams.toString()}`,
                    {
                        headers: {
                            "Authorization": this.Authorization,
                            "Content-Type": "application/json"
                        },
                        responseType: 'blob'
                    }
                );
                console.log(response.data);
                const vi_Imgurl = URL.createObjectURL(response.data);
                this.vi_imageUrl = vi_Imgurl;


                //红外图像获取
                this.acquireimgaeForm.FileType = "ir";

                const queryParams1 = new URLSearchParams(this.acquireimgaeForm); // 如果需要发送对象，可以先转换成字符串

                const response1 = await this.$http.get(`/dataset/getfile?${queryParams1.toString()}`,
                    {
                        headers: {
                            "Authorization": this.Authorization,
                            "Content-Type": "application/json"
                        },
                        responseType: 'blob'
                    }
                );
                console.log(response1.data);
                const ir_Imgurl = URL.createObjectURL(response1.data);
                this.ir_imageUrl = ir_Imgurl;


            } catch (error) {
                console.error(error);
                this.$message.error('Failed to load image');
            }
        },


        // 点击tab
        handleClick(tab, event) {
            console.log(tab, event);
            this.activeName = tab.name;
            if (tab.name == "first") {
                this.getImage();
            }
        },

        // 关闭对话框
        addDialogClosed() {
            this.fileList = [];
            this.form.Name = '';
            this.form.SrcPaper = '';
            this.form.Description = '';
            this.fileError = '';
        },


        addviewDialogClosed() {
            this.filenames_list = [];
            this.vi_imageUrl = '';
            this.ir_imageUrl = '';
        }



    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.el-card__body {
    padding: 10px;
}

.userCard {
    height: 180px;
    display: flex;
    border-bottom: 2px solid #DCDFE6;
    border-radius: 2px;
}

.userInfo {
    width: auto;
    padding: 6% 0 0 6%;
}

.important-font {
    font-weight: 900;
    font-size: 25px;
}

.secondary-font {
    color: #909399;
}

.login-info {
    height: 40px;
    text-align: left;
    color: #909399;
}

.tableInfo {
    margin: 20px 0 0 0;
}

.OrderCard {
    margin: 0 0 30px 30px;
    border: #DCDFE6 1px solid;
    border-radius: 10px;

    i {
        width: 30%;
        line-height: 120px;
        font-size: 30px;
        color: #fff
    }

    div {
        width: 300px;
    }
}

.el-card {
    border: none;
}

.num {
    display: flex;
    flex-wrap: wrap;
}

.graph {
    margin: 15px 0 0 0;
}

.el-calendar {
    height: 265px;
}

.error {
    color: rgb(226, 14, 14);
}
</style>